export default function ThreePillarsSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#F0FDF4]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#065F46] mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            アスロン整体の3つの強み
          </h2>
          <div className="flex items-center justify-center gap-4 mt-6">
            <div className="w-16 h-0.5 bg-[#10B981]"></div>
            <span className="text-sm text-[#666666] tracking-wider">Three Strengths</span>
            <div className="w-16 h-0.5 bg-[#10B981]"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-[#ECFDF5]">
            <div className="w-20 h-20 flex items-center justify-center bg-[#ECFDF5] rounded-full mb-6 mx-auto">
              <i className="ri-body-scan-line text-4xl text-[#10B981]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#065F46] mb-4 text-center" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              関節センサーにアプローチ
            </h3>
            <p className="text-base text-[#333333] leading-relaxed text-center" style={{ lineHeight: '2.0' }}>
              関節センサーとは関節内にある位置や速さを脳に伝達する&ldquo;センサー&rdquo;のことです。このセンサーが乱れると、動作時の痛みにつながります。
            </p>
          </div>

          <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-[#ECFDF5]">
            <div className="w-20 h-20 flex items-center justify-center bg-[#ECFDF5] rounded-full mb-6 mx-auto">
              <i className="ri-search-line text-4xl text-[#10B981]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#065F46] mb-4 text-center" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              筋線維にアプローチ
            </h3>
            <p className="text-base text-[#333333] leading-relaxed text-center" style={{ lineHeight: '2.0' }}>
              問題の部位の筋肉の筋細胞リリースを行い、　細胞レベルで筋線維をパラパラにほぐします。
            </p>
          </div>

          <div className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-[#ECFDF5]">
            <div className="w-20 h-20 flex items-center justify-center bg-[#ECFDF5] rounded-full mb-6 mx-auto">
              <i className="ri-heart-pulse-line text-4xl text-[#10B981]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#065F46] mb-4 text-center" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              血流・姿勢へのアプローチ
            </h3>
            <p className="text-base text-[#333333] leading-relaxed text-center" style={{ lineHeight: '2.0' }}>
              整体の技術で血液の流れを促し、姿勢の崩れを整えます。身体が本来持っている免疫力を上げ、楽に動ける身体へ導きます。
            </p>
          </div>
        </div>

        <div className="text-center">
          <div className="inline-block bg-[#10B981] rounded-3xl px-12 py-8 shadow-xl">
            <p className="text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              痛みの原因を追究し、この3つの強みで根本から改善します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}